import script from "./add-order.vue?vue&type=script&setup=true&lang=js"
export * from "./add-order.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__